import "Styles/templates/page.clp.scss";

import productSliderApp from '../vue/product-slider/index';

productSliderApp();